export enum DetailViewContentElementCapability {
  labelable = 1,
  selectable = 2,
  lockable = 3,
  helpTextable = 4,
  dynamicLabelable = 5,
  visibilityConditionable = 6,
  formattable = 7,
  listFormattable = 8,
}
